import Auth from "@verivest/shared-components/src/auth/Auth";
export { accessTokenCookieName } from "@verivest/shared-components/src/auth/Auth";
export default Auth;
